import { createContext, useContext, ReactNode } from 'react';

export type NavigateFn = (path: string) => void;

const noop: NavigateFn = () => {};
const NavigateContext = createContext<NavigateFn>(noop);

interface NavigateProviderProps {
  navigate: NavigateFn;
  children: ReactNode;
}

export const NavigateProvider = ({ navigate, children }: NavigateProviderProps) => {
  return <NavigateContext.Provider value={navigate}>{children}</NavigateContext.Provider>;
};

export const useNavigateContext = (): NavigateFn => {
  const navigate = useContext(NavigateContext);
  if (!navigate) {
    console.warn('[useNavigateContext] using noop, context value is falsy');
    return noop;
  }
  return navigate;
};
